import React from "react";

import ErrorExceptionPage from "../../../pages/ErrorExceptionPage";

export default class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    const { error, errorInfo }: any = this.state;
    if (errorInfo) {
      console.warn(error);
      // Error path
      return <ErrorExceptionPage {...{ error, errorInfo }} />;
    }
    // Normally, just render children
    return this.props?.children;
  }
}

export function errorBoundary(WrappedComponent: any) {
  return class extends ErrorBoundary {
    render() {
      const { error, errorInfo }: any = this.state;
      if (errorInfo) {
        console.warn(error);
        // Error path
        return <ErrorExceptionPage {...{ error, errorInfo }} />;
      }
      //Normally, just render wrapped component
      return <WrappedComponent {...this.props} />;
    }
  };
}
